import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Collapse, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getVillage, resetVillageState } from "../../../store/village/action";
import { getAgent, resetAgentState } from "../../../store/agent/action";
import { getCustomerGroup, resetCustomerGroupState } from "../../../store/customerGroup/action";
import { getBank } from "../../../store/bank/action";
import { getIdentityType } from "../../../store/identityType/action";
import { resetCustomerState, getCustomer as onGetCustomers, addNewCustomer as onAddNewCustomer, updateCustomer as onUpdateCustomer, deleteCustomer as onDeleteCustomer, getCustomerLoading } from "../../../store/customer/action";

import defaultImg from "../../../assets/images/users/user-dummy-img.jpg";

import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import ExportDoc from "../../../Components/Common/ExportDoc";

const Customer = (props) => {
  const [placeDefaultVal, setPlaceDefaultVal] = useState("");
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [logo, setLogo] = useState(defaultImg);
  const [modalMedia, setModalMedia] = useState(false);
  const [otherDocImg, setOtherDocImg] = useState([]);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, customers, isCustomerCreated, isCustomerSuccess, loading, error, customerGroups, customerGroupsLoading, villages, villageLoading, companies, companyLoading, clients, clientLoading, banks, bankLoading, agents, agentLoading, identityTypes, identityTypeLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    customers: state.Customer.customers,
    isCustomerCreated: state.Customer.isCustomerCreated,
    isCustomerSuccess: state.Customer.isCustomerSuccess,
    loading: state.Customer.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    banks: state.Bank.banks,
    bankLoading: state.Bank.loading,
    villages: state.Village.villages,
    villageLoading: state.Village.loading,
    error: state.Customer.error,
    customerGroups: state.CustomerGroup.customerGroups,
    customerGroupsLoading: state.CustomerGroup.loading,
    agents: state.Agent.agents,
    agentLoading: state.Agent.loading,
    identityTypes: state.IdentityType.identityTypes,
    identityTypeLoading: state.IdentityType.loading,
  }));

  const [customerList, setCustomerList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [customerGroupList, setCustomerGroupList] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [customerContactItem, setCustomerContactItem] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [bankList, setBankList] = useState([]);
  const [customerImg, setSCustomerImg] = useState([]);
  const [identityTypeList, setIdentityTypeList] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [printDoc, setPrintDoc] = useState([]);

  const [open, setOpen] = useState("1");
  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen(open);
    } else {
      setOpen(id);
    }
  };

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const statusGenderData = [
    {
      options: [
        { label: "Pria", value: "Pria" },
        { label: "Wanita", value: "Wanita" },
      ],
    },
  ];

  const sourceTypeData = [
    {
      options: [
        { label: "TIKTOK", value: "TIKTOK" },
        { label: "INSTAGRAM", value: "INSTAGRAM" },
        { label: "FACEBOOK", value: "FACEBOOK" },
        { label: "YOUTUBE", value: "YOUTUBE" },
        { label: "WEBSITE", value: "WEBSITE" },
        { label: "BROSUR", value: "BROSUR" },
        { label: "MEMBER", value: "MEMBER" },
        { label: "KERABAT / TEMAN", value: "KERABAT / TEMAN" },
        { label: "LAIN-LAIN", value: "LAIN-LAIN" },
      ],
    },
  ];

  const onClickDelete = (customer) => {
    setCustomer(customer);
    setDeleteModal(true);
  };

  const onClickApprove = (customer) => {
    setCustomer(customer);
    setApproveModal(true);
  };

  const handleDeleteCustomer = () => {
    if (customer) {
      dispatch(onDeleteCustomer(customer));
      setDeleteModal(false);
    }
  };

  const handleApproveCustomer = () => {
    if (customer) {
      customer.setApprove = true;
      dispatch(onUpdateCustomer(customer));
      setApproveModal(false);
    }
  };

  const handleAgent = (e) => {
    validation.setFieldValue("agent", "");
    dispatch(getAgent({ simple: true }));
  };

  // useEffect(() => {
  //   setCustomerList(customers);
  // }, [customers]);

  useEffect(() => {
    dispatch(getIdentityType());
    dispatch(resetCustomerState());
    dispatch(onGetCustomers({ simple: true }));
    handleGetGroup(userData?.companyId);
    handleAgent(userData?.companyId);
  }, []);

  useEffect(() => {
    if (!isEmpty(customers)) {
      let filteredCustomers = customers;
      if (activeTypeTab !== "all") {
        filteredCustomers = customers.filter((customer) => customer.customer_status.name === activeTypeTab);
      }
      setCustomerList(filteredCustomers.map((el) => ({ ...el, isChecked: false })));
      setInfo(customers[customers.length - 1]);
      setIsEdit(false);
    }
  }, [customers]);

  useEffect(() => {
    var data = [];
    var opt = [];
    agents.forEach((item, key) => {
      const name = item.name;
      const company = item.agency_agent ? " - " + item.agency_agent.name : "";
      const id = item.id;
      var obj = { label: name + company, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);
    setAgentList(data);
  }, [agents]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    customerGroups.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (customerGroups.length > 0) {
      setCustomerGroupList(data);
    }
  }, [customerGroups]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(identityTypes)) {
      var data = [];
      var opt = [];
      identityTypes.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setIdentityTypeList(data);
    }
  }, [identityTypes]);

  const handleDeleteFileCustomer = (file) => {
    if (isEdit) {
      const newState = customerImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setSCustomerImg(newState);
    } else {
      const index = customerImg.findIndex((fl) => fl.filename === file.filename);
      setSCustomerImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      default:
        setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  useEffect(() => {
    if (!isEmpty(villages)) {
      var villageData = [];
      var opt = [];
      villages.forEach((item, key) => {
        const village_name = item.village_name;
        const id = item.id;
        const city_name = item.vc.city_name;
        const district_name = item.vd.district_name;
        const province_name = item.vp.province_name;
        var obj = {
          label: village_name + ", " + district_name + ", " + city_name + " - " + province_name,
          value: id,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      villageData.push(option);
      setVillageList(villageData);
    }
  }, [villages]);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredCustomers = customers;
      if (type !== "all") {
        filteredCustomers = customers.filter((customer) => customer.customer_status.name === type);
      }
      setCustomerList(filteredCustomers);
    }
  };

  useEffect(() => {
    if (banks && !banks.length) {
      dispatch(getBank());
    }
  }, [dispatch, banks]);

  useEffect(() => {
    if (!isEmpty(banks)) {
      var data = [];
      var opt = [];
      banks.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankList(data);
    }
  }, [banks]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCustomer(null);
      setCustomerContactItem([]);
      setCustomerGroupList([]);
      setPlaceDefaultVal("");
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleGetGroup = useCallback(
    (companyId) => {
      dispatch(resetCompanyState());
      dispatch(getCustomerGroup({ companyId: companyId }));
    },
    [dispatch],
  );

  const handleCustomerClick = useCallback(
    (arg) => {
      const customer = arg;
      let venaddress = [];
      let venbank = [];
      let vencustomer = [];
      customer.customer_address.forEach((address) => {
        if (address.isPrimary) venaddress = address;
      });
      const addressName = venaddress ? venaddress.address_name : "";
      const addressLabel = venaddress ? venaddress.description : "";
      const addressValue = venaddress ? venaddress.villageId : "";

      let address_customer = {};
      for (const address of customer.customer_address) {
        if (address.isPrimary) {
          address_customer = address;
        }
      }

      let files = [];
      for (const f of customer.customer_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }

      let identity_customer = {};
      for (const identity of customer.customer_identity) {
        if (identity.isPrimary) {
          identity_customer = identity;
        }
      }

      setSCustomerImg(files);
      customer.customer_bank.forEach((bank) => {
        if (bank.isPrimary) venbank = bank;
      });

      if (customer.customer_contact) {
        customer.customer_contact.forEach((element) => {
          vencustomer.push({
            id: element.id,
            name: element.name,
            email: element.email,
            phone: element.phone,
            position: element.position,
          });
        });
        setCustomerContactItem(vencustomer);
      }

      setPlaceDefaultVal({
        label: `${address_customer.village} ${address_customer.district} ${address_customer.city} ${address_customer.province} ${address_customer.country}`,
        value: `${address_customer.village} ${address_customer.district} ${address_customer.city} ${address_customer.province} ${address_customer.country}`,
      });

      setCustomer({
        id: customer.id,
        idBank: venbank.id ?? 0,
        address: {
          label: `${address_customer.village} ${address_customer.district} ${address_customer.city} ${address_customer.province} ${address_customer.country}`,
          value: `${address_customer.village} ${address_customer.district} ${address_customer.city} ${address_customer.province} ${address_customer.country}`,
        },
        street: address_customer.description ?? "",
        zip: address_customer.code ?? "",
        village: address_customer.village ?? "",
        district: address_customer.district ?? "",
        city: address_customer.city ?? "",
        province: address_customer.province ?? "",
        country: address_customer.country ?? "",
        name: customer.name,
        password: customer.customer_user ? customer.customer_user.pass : "",
        agent:
          customer.customer_agent === null
            ? ""
            : {
              label: customer.customer_agent ? customer.customer_agent.name : "",
              value: customer.customer_agent ? customer.customer_agent.id : "",
            },
        identityType: {
          label: identity_customer.identity_type ? identity_customer.identity_type.name : "",
          value: identity_customer.identity_type ? identity_customer.identity_type.id : "",
        },
        identity: identity_customer.identity_number ?? "",
        email: customer.email,
        phone: customer.phone,
        insurance_number: customer.insurance_number,
        image: customer.image,
        tax_number: customer.tax_number,
        website: customer.website,
        description: customer.description,
        source_type: customer.source_type ? { value: customer.source_type, label: customer.source_type } : null,
        visitedat: customer.visitedat,
        description_result: customer.description_result,
        description_visit: customer.description_visit,
        number: venbank.number,
        bank: venbank.bank_data_bank && {
          label: venbank.bank_data_bank.name,
          value: venbank.bankId,
        },
        customer_status: {
          label: customer.customer_status.name,
          value: customer.customer_status.id,
        },
        customerGroup: customer.customer_group_customer && {
          label: customer.customer_group_customer ? customer.customer_group_customer.name : "",
          value: customer.customer_group_customer ? customer.customer_group_customer.id : "",
        },
        customer_contact: vencustomer,
        client: customer.customer_client && {
          label: customer.customer_client ? customer.customer_client.name : "",
          value: customer.customer_client ? customer.customer_client.id : "",
        },
        company: customer.customer_company && {
          label: customer.customer_company ? customer.customer_company.name : "",
          value: customer.customer_company ? customer.customer_company.id : "",
        },
      });

      handleGetGroup(customer.customer_company.id);

      setIsEdit(true);
      toggle();
    },
    [toggle, userType],
  );

  useEffect(() => {
    let dataDoc = [

      {
        id: "visitedat",
        label: "Tanggal Kunjungan",
        isSelected: true,
        data: [],
      },
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "customer_agent",
        label: "Sales",
        isSelected: true,
        data: [],
      },
      {
        id: "phone",
        label: "Telepon",
        isSelected: true,
        data: [],
      },
      {
        id: "email",
        label: "Email",
        isSelected: true,
        data: [],
      },
      {
        id: "source_type",
        label: "Sumber",
        isSelected: true,
        data: [],
      },
      {
        id: "description_visit",
        label: "Tujuan Kunjungan",
        isSelected: true,
        data: [],
      },
      {
        id: "description_result",
        label: "Hasil Kunjungan",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "customer_status",
        label: "Status",
        isSelected: true,
        data: [],
      },
    ];

    if (customerList.length > 0) {
      customerList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "customer_status") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "customer_agent") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [customerList]);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = customerList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setCustomerList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = customerList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setCustomerList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateCustomer") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleCustomerClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteCustomer") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {cellProps.row.original.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" ? "btn-label btn btn-sm btn-soft-success fs-12 ms-2" : userRole && userRole.split(",").indexOf("approveCustomer") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 ms-2" : "btn-label btn btn-sm btn-soft-success fs-12 ms-2 d-none"}
                  onClick={() => {
                    onClickApprove(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Nama",
        filterable: true,
        accessor: "name",
        Cell: (customer) => {
          const data = customer.row.original;
          let status;
          switch (data?.customer_status?.name) {
            case "DRAFT":
              status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.customer_status?.name} </span>;
              break;
            case "ACTIVE":
              status = <span className="badge fs-10 text-uppercase badge-soft-info"> {data?.customer_status?.name} </span>;
              break;
            case "INACTIVE":
              status = <span className="badge fs-10 text-uppercase badge-soft-danger"> {data?.customer_status?.name} </span>;
              break;
            default:
              status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.customer_status?.name} </span>;
              break;
          }

          return <div>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                {customer.row.original.image ? (
                  <img src={customer.row.original.image === "" ? logo : `${api.MEDIA_URL}/media/${customer.row.original.image}`} alt="" className="avatar-xs rounded-circle me-1" />
                ) : (
                  <div className="flex-shrink-0 avatar-xs me-1">
                    <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{customer.row.original.name.charAt(0)}</div>
                  </div>
                )}
              </div>
              <div className="flex-grow-1 ms-2 name">
                <p className="mb-1">{customer.row.original.name}</p>
                <p className="mb-1 fs-11">{customer.row.original.phone}</p>
                <p className="mb-1 fs-11">{customer.row.original.email}</p>
                {status}
              </div>
            </div>
          </div>
        }
      },
      {
        Header: "Tgl Kunjungan",
        accessor: (data) => data.visitedat ? handleValidDate(data.visitedat) : "-",
        filterable: true,
      },

      {
        Header: "Tujuan",
        accessor: "description_visit",
        filterable: true,
      },
      {
        Header: "Hasil",
        accessor: "description_result",
        filterable: true,
      },
      {
        id: "Email",
        Header: "Email",
        accessor: "email",
        filterable: true,
      },
      {
        id: "Telepon",
        Header: "Telepon",
        accessor: "phone",
        filterable: true,
      },
      {
        id: "Status",
        Header: "Status",
        accessor: "customer_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [customerList, handleCustomerClick, logo, userRole, userType, isCheckAll],
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: customerList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Email", "Telepon"],
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      simple: true,
    };
    dispatch(onGetCustomers(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setCustomerList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    dispatch(resetCustomerState());
    dispatch(onGetCustomers({ simple: true }));
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      company: (customer && customer.company) || companySelected,
      client: (customer && customer.client) || clientSelected,
      customerGroup: (customer && customer.customerGroup) ?? "",
      name: (customer && customer.name) ?? "",
      agent: (customer && customer.agent) ?? "",
      email: (customer && customer.email) ?? "",
      password: (customer && customer.password) ?? "",
      phone: (customer && customer.phone) ?? "",
      birthat: (customer && customer.birthat) ?? "",
      insurance_number: (customer && customer.insurance_number) ?? "",
      tax_number: (customer && customer.tax_number) ?? "",
      identity: (customer && customer.identity) ?? "",
      identity_type: (customer && customer.identityType) ?? "",
      number: (customer && customer.number) ?? "",
      website: (customer && customer.website) ?? "",
      description: (customer && customer.description) ?? "",
      address: (customer && customer.address) ?? "",
      customer_status: customer && customer.customer_status,
      village: customer && customer.village,
      bank: (customer && customer.bank) ?? "",
      idBank: (customer && customer.idBank) || 0,
      zip: (customer && customer.zip) ?? "",
      street: (customer && customer.street) ?? "",
      image: (customer && customer.image) ?? "",
      source_type: (customer && customer.source_type) ?? "",
      visitedat: (customer && customer.visitedat) ?? "",
      description_result: (customer && customer.description_result) ?? "",
      description_visit: (customer && customer.description_visit) ?? "",
    },
    validationCutomerSchema: Yup.object({
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      company: Yup.object().required("Please Select Company").nullable(true),
      agent: Yup.object().required("Please Select Agent").nullable(true),
      name: Yup.string().required("Nama").nullable(true),
      phone: Yup.string().required("Silahkan Input Phone Number").nullable(true),
      visitedat: Yup.string().required("Please Input Tanggal Kunjungan").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getCustomerLoading());
      if (isEdit) {
        let editDataSubmit = {
          id: customer.id,
          groupId: values.customerGroup.value,
          clientId: values.client.value,
          companyId: values.company.value,
          agentId: values.agent.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          insurance_number: values.insurance_number,
          tax_number: values.tax_number,
          identityId: values.identity_type.value,
          identity: values.identity,
          website: values.website,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          source_type: values.source_type?.value ?? "",
          visitedat: values.visitedat,
          description: values.description,
          description_result: values.description_result,
          description_visit: values.description_visit,
          zip: values.zip,
          village: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[0].value : customer.village,
          district: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 4].value : customer.district,
          city: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 3].value : customer.city,
          province: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 2].value : customer.province,
          country: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 1].value : customer.country,
          street: values.street,
          customer_contact: JSON.stringify(customerContactItem),
          image: values.image,
        };

        dispatch(onUpdateCustomer(editDataSubmit));
      } else {
        var addDataSubmit = {
          clientId: values.client.value,
          companyId: values.company.value,
          groupId: values.customerGroup.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          insurance_number: values.insurance_number,
          tax_number: values.tax_number,
          identityId: values.identity_type.value,
          identity: values.identity,
          website: values.website,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          agentId: values.agent.value,
          source_type: values.source_type?.value ?? "",
          visitedat: values.visitedat,
          description: values.description,
          description_result: values.description_result,
          description_visit: values.description_visit,
          zip: values.zip,
          village: values.address.value && values.address.value.terms[0].value,
          district: values.address.value && values.address.value.terms[values.address.value.terms.length - 4].value,
          city: values.address.value && values.address.value.terms[values.address.value.terms.length - 3].value,
          province: values.address.value && values.address.value.terms[values.address.value.terms.length - 2].value,
          country: values.address.value && values.address.value.terms[values.address.value.terms.length - 1].value,
          street: values.street,
          customer_contact: JSON.stringify(customerContactItem),
          image: values.image,
        };

        dispatch(onAddNewCustomer(addDataSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  function handleCustomerContactAdd() {
    let fc = [];
    if (customerContactItem && customerContactItem.length) {
      customerContactItem.forEach((element) => {
        fc.push(element);
      });
    }

    fc.push({
      name: "",
      email: "",
      phone: "",
    });
    setCustomerContactItem(fc);
  }

  // const checkedAll = () => {
  //   const checkall = document.getElementById("checkBoxAll");
  //   const ele = document.querySelectorAll(".dataCheckbox");

  //   if (checkall.checked) {
  //     ele.forEach((ele) => {
  //       ele.checked = true;
  //     });
  //   } else {
  //     ele.forEach((ele) => {
  //       ele.checked = false;
  //     });
  //   }
  // };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCustomer(element.value));
    });
    checkall.checked = false;
  };

  document.title = "Konsumen | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={customerList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCustomer} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={customer && customer.name ? customer.name : ""} show={approveModal} onApproveClick={handleApproveCustomer} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Sales dan Konsumen" pageTitle="Konsumen" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createCustomer") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-group-line me-1 align-bottom fs-14"></i>Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger ms-1 add-btn" : userRole && userRole.split(",").indexOf("deleteCustomer") !== -1 ? "btn btn-soft-danger ms-1 add-btn" : "btn btn-soft-danger ms-1 add-btn d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={8}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#">
                        <i className=" ri-group-line me-1 align-bottom fs-14"></i>SEMUA KONSUMEN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#">
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-3">
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={1}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Konsumen" : "Tambah Konsumen"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="agent-field" className="form-label">
                              Marketing
                              {agentLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="agent"
                              value={validation.values.agent}
                              placeholder="Pilih Marketing / Agen"
                              isDisabled={agentList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("agent", e);
                              }}
                              options={agentList}
                            ></Select>
                            {validation.touched.agent && validation.errors.agent && <FormFeedback type="invalid">{validation.errors.agent}</FormFeedback>}
                          </div>

                          <div className="mb-3 d-none">
                            <Label htmlFor="customerGroup-field" className="form-label">
                              Customer Group (Optional)&nbsp;
                              {customerGroupsLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="customerGroup"
                              value={validation.values.customerGroup}
                              placeholder="Select Customer Group"
                              isDisabled={customerGroupList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("customerGroup", e);
                              }}
                              options={customerGroupList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <label>Tanggal Kunjungan</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validation.setFieldValue("visitedat", dateStr);
                              }}
                              value={validation.values.visitedat ?? ""}
                            />
                            {validation.touched.visitedat && validation.errors.visitedat ? <FormFeedback type="invalid">{validation.errors.visitedat}</FormFeedback> : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="customername-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="customername-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="password-field" className="form-label">
                              Password <span className="text-danger">*</span>
                            </Label>
                            <Input name="password" id="password-field" className="form-control" placeholder="Isi Password" type="password" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.password ?? ""} invalid={validation.touched.password && validation.errors.password ? true : false} />
                            {validation.touched.password && validation.errors.password ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.password}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="phone-field" className="form-label">
                              No. Telepon
                            </Label>
                            <Input name="phone" id="phone-field" className="form-control" placeholder="Isi No. Telepon" type="text"
                              onChange={(e) => {
                                validation.setFieldValue("phone", e.target.value);
                                validation.setFieldValue("email", e.target.value + '@mail.com');
                              }}
                              onBlur={validation.handleBlur} value={validation.values.phone ?? ""} invalid={validation.touched.phone && validation.errors.phone ? true : false} />
                            {validation.touched.phone && validation.errors.phone ? <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="email-field" className="form-label">
                              Email
                            </Label>
                            <Input name="email" id="email-field" className="form-control" placeholder="Isi Email" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.email ?? ""} invalid={validation.touched.email && validation.errors.email ? true : false} />
                            {validation.touched.email && validation.errors.email && <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="pekerjaan-field" className="form-label">
                              Sumber Kunjungan
                            </Label>
                            <Select
                              name="source_type"
                              value={validation.values.source_type}
                              placeholder="Pilih Sumber Kunjungan"
                              onChange={(e) => {
                                validation.setFieldValue("source_type", e);
                              }}
                              options={sourceTypeData}
                            ></Select>
                          </div>

                          <div className="mb-3 d-none">
                            <Label htmlFor="des-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="address" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.address ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="street-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="street" id="street-field" className="form-control" placeholder="Isi Alamat" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.street} invalid={validation.touched.street && validation.errors.street ? true : false} />
                            {validation.touched.street && validation.errors.street && <FormFeedback type="invalid">{validation.errors.street}</FormFeedback>}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="zip-field" className="form-label">
                              Kode Pos
                            </Label>
                            <Input name="zip" id="zip-field" className="form-control" placeholder="Isi Kode Pos" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.zip ?? ""} />
                          </div>
                        </div>

                        <div className="col-lg-6 mb-3">
                          <div className="row">
                            <div className="col-md-5 mb-3">
                              <Label htmlFor="identity_type" className="form-label">
                                Jenis ID{" "}
                                {identityTypeLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="identity_type"
                                value={validation.values.identity_type}
                                placeholder="Jenis ID"
                                onChange={(e) => {
                                  validation.setFieldValue("identity_type", e);
                                }}
                                options={identityTypeList}
                              ></Select>
                              {validation.touched.identity_type && validation.errors.identity_type ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.identity_type}
                                </small>
                              ) : null}
                            </div>
                            <div className="col-md-7 mb-3">
                              <Label htmlFor="identity_type" className="form-label">
                                Nomor Identitas
                              </Label>
                              <Input name="identity" id="identity-field" className="form-control" placeholder="Isi No. Identitas" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.identity ?? ""} invalid={validation.touched.identity && validation.errors.identity ? true : false} />
                              {validation.touched.identity && validation.errors.identity ? <FormFeedback type="invalid">{validation.errors.identity}</FormFeedback> : null}
                            </div>
                          </div>
                          <div className=" mb-3">
                            <Label htmlFor="bank-field" className="form-label">
                              Bank
                            </Label>
                            <Select
                              name="bank"
                              value={validation.values.bank}
                              placeholder="Pilih Bank"
                              onChange={(e) => {
                                validation.setFieldValue("bank", e);
                              }}
                              options={bankList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="number-field" className="form-label">
                              No. Rekening
                            </Label>
                            <Input name="number" id="number-field" className="form-control" placeholder="Isi No. Rekening" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.number ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="tax_number-field" className="form-label">
                              No. Pajak
                            </Label>
                            <Input name="tax_number" id="tax_number-field" className="form-control" placeholder="Isi No. Pajak" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tax_number ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="insurance_number-field" className="form-label">
                              No. BPJS
                            </Label>
                            <Input name="insurance_number" id="insurance_number-field" className="form-control" placeholder="Isi No. Pajak" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.insurance_number ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description_visit-field" className="form-label">
                              Tujuan Kunjungan
                            </Label>
                            <Input name="description_visit" id="description_visit-field" className="form-control" placeholder="Input Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description_visit} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description_result-field" className="form-label">
                              Hasil Kunjungan
                            </Label>
                            <Input name="description_result" id="description_result-field" className="form-control" placeholder="Input Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description_result} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description-field" className="form-label">
                              Keterangan (jika ada)
                            </Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Input Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} />
                          </div>
                          <div className="mb-3 position-relative">
                            <Label htmlFor="customer_contact" className="form-label">
                              Kontak Darurat
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                handleCustomerContactAdd();
                              }}
                            >
                              <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Tambah
                            </button>
                          </div>
                          {customerContactItem.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3 d-flex gap-3 align-items-center">
                                <div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Nama Kontak
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.name`}
                                        className="form-control"
                                        placeholder="Isi Nama Kontak"
                                        type="text"
                                        value={customerContactItem[i].name ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`customerContactItem.${i}.name`, e.target.value);
                                          customerContactItem[i].name = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        No. Telepon Kontak
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.phone`}
                                        className="form-control"
                                        placeholder="Isi Telepon"
                                        type="text"
                                        value={customerContactItem[i].phone ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`customerContactItem.${i}.phone`, e.target.value);
                                          customerContactItem[i].phone = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Email
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.email`}
                                        className="form-control"
                                        placeholder="Isi Email"
                                        type="text"
                                        value={customerContactItem[i].email ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`customerContactItem.${i}.email`, e.target.value);
                                          customerContactItem[i].email = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Hubungan Dengan Konsumen
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.position`}
                                        className="form-control"
                                        placeholder="Isi Hubungan"
                                        type="text"
                                        value={customerContactItem[i].position ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`customerContactItem.${i}.position`, e.target.value);
                                          customerContactItem[i].position = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <Button
                                  className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                                  style={{ width: "70px" }}
                                  onClick={() => {
                                    setCustomerContactItem((val) => [...val.slice(0, i), ...val.slice(i + 1)]);
                                  }}
                                >
                                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                </Button>
                              </div>
                            );
                          })}
                          <div className="mb-3 position-relative">
                            <Label htmlFor="customer_contact" className="form-label">
                              Dokumen Konsumen
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                setMediaType("imageCostumer");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {customerImg.map((f, i) => {
                            if (f.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      <img src={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>

                                    <div className="text-truncate">{f.filename}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          handleDeleteFileCustomer(f);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                          {/* {validation.values.image !== "" && (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.image === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>
                                <div className="text-truncate">
                                  {validation.values.image}
                                </div>
                                <div>
                                  <Link to="#" className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"} onClick={(e) => {
                                    validation.setFieldValue("image", "");
                                  }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          )} */}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light" onClick={toggle}>
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update Data Konsumen" : "Simpan Data Konsumen"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
          <Col xxl={4}>
            <Card>
              <div className="card-body">
                <div className="table-responsive table-card">
                  <Accordion id="default-accordion-example" flush open={open} toggle={toggleAccordion}>
                    <AccordionItem>
                      <AccordionHeader targetId="1" className="accordion-header" id="headingOne">
                        INFORMASI UMUM
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    DATA KONTAK DARURAT
                                  </td>
                                </tr>
                                {info.customer_contact ? (
                                  info.customer_contact.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2">Name</td>
                                          <td className="p2">{row.name ? row.name : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Email</td>
                                          <td className="p2">{row.email ? row.email : "-"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Phone</td>
                                          <td className="p2">{row.phone ? row.phone : "-"} </td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })
                                ) : (
                                  <tr></tr>
                                )}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    DATA ALAMAT
                                  </td>
                                </tr>
                                {info.customer_address ? (
                                  info.customer_address.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2">Address</td>
                                          <td className="p2">
                                            {row.description ? row.description : "-"} - {row.code ? row.code : ""}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="p2" colSpan={"2"}></td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })
                                ) : (
                                  <tr></tr>
                                )}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    DATA BANK
                                  </td>
                                </tr>
                                {info.customer_bank ? (
                                  info.customer_bank.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2" colSpan="2">
                                            {row.bank_data_bank ? row.bank_data_bank.name : "-"}{" "}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Primary</td>
                                          <td className="p2">{row.isPrimary ? "Yes" : "No"} </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">No. Rekening Bank</td>
                                          <td className="p2">{row.number ? row.number : "-"} </td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })
                                ) : (
                                  <tr></tr>
                                )}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2">No. Pajak</td>
                                  <td className="p2">{info.tax_number ? info.tax_number : "-"} </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="2" className="accordion-header" id="headingTwo">
                        INFORMASI KONTAK
                      </AccordionHeader>
                      <AccordionBody accordionId="2">
                        <div className="col-lg-12">
                          {(info.customer_contact || []).map((row) => {
                            return (
                              <table className="table border table-responsive table-striped fs-13 mb-3" key={row.id}>
                                <tbody>
                                  <tr>
                                    <td className="p2">Name</td>
                                    <td className="p2">{row.name ? row.name : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Position</td>
                                    <td className="p2">{row.position ? row.position : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Email</td>
                                    <td className="p2">{row.email ? row.email : "-"} </td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Phone</td>
                                    <td className="p2">{row.phone ? row.phone : "-"} </td>
                                  </tr>
                                </tbody>
                              </table>
                            );
                          })}
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="3" className="accordion-header" id="headingThree">
                        INFORMASI LAINNYA
                      </AccordionHeader>
                      <AccordionBody accordionId="3">
                        <table className="table table-responsive table-striped fs-12">
                          <tbody>
                            <tr>
                              <td className="p2">Dibuat Oleh</td>
                              <td className="p2">{info.customer_createdby && info.customer_createdby.name ? info.customer_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2">Diedit Oleh</td>
                              <td className="p2">{info.customer_updatedby && info.customer_updatedby.name ? info.customer_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2">Approved By</td>
                              <td className="p2">{info.customer_approvedby && info.customer_approvedby.name ? info.customer_approvedby.name + " - " + handleValidDate(info.approvedat) : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Customer.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Customer));
